import React, { Component } from 'react';
import withAppLayout from '../components/appLayout';
import AmcFundsListNew from './amcNew';
import { Fund } from '../models/singleFundPages';

interface Props {
  funds: Fund[];
  slug: string;
  primarySlug: string;
  statusCode: number;
  url: any;
  amcBasicsDetails: any;
  amcs: any;
  issuingAuthority: string;
  customContent: string;
}

class AmcFundsList extends Component<Props> {
  constructor(props: Props) {
    super(props);
  }

  public render() {
    return (
      <div>
        <AmcFundsListNew {...this.props} />
      </div>
    );
  }
}

export default withAppLayout({ hideDefaultCanonical: true }, AmcFundsList);



// WEBPACK FOOTER //
// ./pages/amc.tsx